<template>
  <header id="site-header" class="site-header" :class="{ 'open' : isOpen }">
    <div class="content-max-width flex align-center">
      <a href="/" class="logo">
        <img src="/images/logo.png" alt="Website Logo" class="desktop" />
        <img src="/images/logo-mobile.svg" alt="Website Logo" class="mobile" />
      </a>

      <nav>
        <ul class="top desktop" v-if="custom.length == 0">
          <li><a :href="data.wo.url">{{ data.wo.title }}</a></li>
          <app-collapsible tag="li">
            <template #trigger="{ isOpen, toggle }">
              <a @click="toggle" style="cursor:pointer;">Who we are <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
            </template>

            <template #collapsible="{ isOpen }">
              <ul v-show="isChildOpen" class="children">
                <li>
                  <a v-for="(item, index) of data.menu1"
                    :href="item.url"
                    :key="index">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </template>
          </app-collapsible>
          <app-collapsible tag="li">
            <template #trigger="{ isOpen, toggle }">
              <a @click="toggle" style="cursor:pointer;">Diabetes Matters <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
            </template>
            <template #collapsible="{ isOpen }">
              <ul v-show="isChildOpen" class="children">
                <li>
                  <a v-for="(item, index) of data.menu4"
                    :href="item.url"
                    :key="index">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </template>
          </app-collapsible>
          <app-collapsible tag="li">
            <template #trigger="{ isOpen, toggle }">
              <a @click="toggle" style="cursor:pointer;">Resources <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
            </template>
            <template #collapsible="{ isOpen }">
              <ul v-show="isChildOpen" class="children">
                <li>
                  <a v-for="(item, index) of data.menu2"
                    :href="item.url"
                    :key="index">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </template>
          </app-collapsible>

          <app-collapsible tag="li">
            <template #trigger="{ isOpen, toggle }">
              <a @click="toggle" style="cursor:pointer;">Get involved <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }"  alt=""></a>
            </template>
            <template #collapsible="{ isOpen }">
              <ul v-show="isChildOpen" class="children">
                <li>
                  <a v-for="(item, index) of data.menu3"
                    :href="item.url"
                    :key="index">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </template>
          </app-collapsible>
        </ul>
        <ul class="top desktop" v-else>
          <span v-for="(item,key) in custom" :key="key">
            <li v-if="item.children.length == 0">
              <a :href="item.data.custom_link ? item.data.custom_link : item.url">{{ item.title }}</a>
            </li>
            <app-collapsible tag="li" v-else>
              <template #trigger="{ isOpen, toggle }">
                <a @click="toggle" style="cursor:pointer;">{{item.title}} <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
              </template>

              <template #collapsible="{ isOpen }">
                <ul v-show="isChildOpen" class="children">
                  <li>
                    <!-- <a v-for="(item, index) of data.menu1"
                      :href="item.url"
                      :key="index">
                      {{ item.title }}
                    </a> -->
                    <a v-for="(i,k) in item.children" :key="k"
                      :href="i.data.custom_link ? i.data.custom_link : i.url"
                    >
                      {{ i.title }}
                    </a>
                  </li>
                </ul>
              </template>
            </app-collapsible>
          </span>
          <span>

          </span>
        </ul>


          <ul class="top mobile" v-if="custom.length == 0">
              <li><a :href="data.wo.url">{{ data.wo.title }}</a></li>
              <app-collapsible tag="li">
                  <template #trigger="{ isOpen, toggle }">
                      <a @click="toggle" style="cursor:pointer;">Who we are <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
                  </template>

                  <template #collapsible="{ isOpen }">
                      <ul v-show="isOpen" class="children">
                          <li>
                              <a v-for="(item, index) of data.menu1"
                                 :href="item.url"
                                 :key="index">
                                  {{ item.title }}
                              </a>
                          </li>
                      </ul>
                  </template>
              </app-collapsible>
              <app-collapsible tag="li">
                  <template #trigger="{ isOpen, toggle }">
                      <a @click="toggle" style="cursor:pointer;">Diabetes Matters <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
                  </template>

                  <template #collapsible="{ isOpen }">
                      <ul v-show="isOpen" class="children">
                          <li>
                              <a v-for="(item, index) of data.menu4"
                                 :href="item.url"
                                 :key="index">
                                  {{ item.title }}
                              </a>
                          </li>
                      </ul>
                  </template>
              </app-collapsible>
              <app-collapsible tag="li">
                  <template #trigger="{ isOpen, toggle }">
                      <a @click="toggle" style="cursor:pointer;">Resources <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
                  </template>
                  <template #collapsible="{ isOpen }">
                      <ul v-show="isOpen" class="children">
                          <li>
                              <a v-for="(item, index) of data.menu2"
                                 :href="item.url"
                                 :key="index">
                                  {{ item.title }}
                              </a>
                          </li>
                      </ul>
                  </template>
              </app-collapsible>

              <app-collapsible tag="li">
                  <template #trigger="{ isOpen, toggle }">
                      <a @click="toggle" style="cursor:pointer;">Get involved <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }"  alt=""></a>
                  </template>
                  <template #collapsible="{ isOpen }">
                      <ul v-show="isOpen" class="children">
                          <li>
                              <a v-for="(item, index) of data.menu3"
                                 :href="item.url"
                                 :key="index">
                                  {{ item.title }}
                              </a>
                          </li>
                      </ul>
                  </template>
              </app-collapsible>
          </ul>

          <ul class="top mobile" v-else>

              <li v-for="(item,key) in custom" :key="key" v-if="item.children.length == 0">
                  <a :href="item.data.custom_link ? item.data.custom_link : item.url">{{ item.title }}</a>
              </li>
              <app-collapsible tag="li" v-else>
                  <template #trigger="{ isOpen, toggle }">
                      <a @click="toggle" style="cursor:pointer;">{{item.title}} <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt=""></a>
                  </template>

                  <template #collapsible="{ isOpen }">
                      <ul v-show="isOpen" class="children">
                          <li>
                              <!-- <a v-for="(item, index) of data.menu1"
                                :href="item.url"
                                :key="index">
                                {{ item.title }}
                              </a> -->
                              <a v-for="(i,k) in item.children" :key="k"
                                 :href="i.data.custom_link ? i.data.custom_link : i.url"
                              >
                                  {{ i.title }}
                              </a>
                          </li>
                      </ul>
                  </template>
              </app-collapsible>
          </ul>

        <div class="social">
          <a  target="_blank" v-for="(item, index) of data.social"
            :href="item.link"
            :key="index">
            <img :src="item.image" :alt="item.alt">
          </a>

          <a :href="data.diabetes.link" class="button" target="_blank">Diabetes NZ <img src="/images/link.svg" alt="" class="link"></a>
        </div>
      </nav>

      <!-- <a href="tel:09-489 6263" class="tel-mob">09-489 6263</a> -->

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf', 'data', 'custom'
  ],
  data() {
    return {
      isOpen: false,
      isChildOpen: true,
    };
  },
  methods: {

    toggleMenu() {
      this.isOpen = !this.isOpen;
    }

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue